module.exports = __webpack_public_path__ + "img/NO947278770.cf5ce5af.png";